@file:OptIn(InternalResourceApi::class)

package chartsproject.charts_demo_shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/chartsproject.charts_demo_shared.generated.resources/"

@delegate:ResourceContentHash(-588_006_564)
public val Res.drawable.charts_logo: DrawableResource by lazy {
      DrawableResource("drawable:charts_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/charts_logo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(722_207_067)
public val Res.drawable.ic_bar_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_bar_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bar_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_168_786_107)
public val Res.drawable.ic_github: DrawableResource by lazy {
      DrawableResource("drawable:ic_github", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_github.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_843_422_439)
public val Res.drawable.ic_histogram_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_histogram_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_histogram_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_109_290_915)
public val Res.drawable.ic_line_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_line_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_line_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_166_240_115)
public val Res.drawable.ic_multi_line_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_multi_line_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_multi_line_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_621_484_548)
public val Res.drawable.ic_pie_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_pie_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_pie_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-345_073_621)
public val Res.drawable.ic_radar_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_radar_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_radar_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_887_890_097)
public val Res.drawable.ic_stacked_area_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_stacked_area_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_stacked_area_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(500_687_149)
public val Res.drawable.ic_stacked_bar_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_stacked_bar_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_stacked_bar_chart.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("charts_logo", Res.drawable.charts_logo)
  map.put("ic_bar_chart", Res.drawable.ic_bar_chart)
  map.put("ic_github", Res.drawable.ic_github)
  map.put("ic_histogram_chart", Res.drawable.ic_histogram_chart)
  map.put("ic_line_chart", Res.drawable.ic_line_chart)
  map.put("ic_multi_line_chart", Res.drawable.ic_multi_line_chart)
  map.put("ic_pie_chart", Res.drawable.ic_pie_chart)
  map.put("ic_radar_chart", Res.drawable.ic_radar_chart)
  map.put("ic_stacked_area_chart", Res.drawable.ic_stacked_area_chart)
  map.put("ic_stacked_bar_chart", Res.drawable.ic_stacked_bar_chart)
}
